import { get } from '../../../helpers/axios';

export const getStatisticsDetail = ({initDate,limitDate}) => get(`campaign-message/statistics`,{params:{initDate,limitDate}});

export const getStatisticsGrouped = ({initDate,limitDate}) => get(`campaign-message/statistics/grouped`,{params:{initDate,limitDate}});